import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

const HelpTooltip = props => {
  const id = `Tooltip-${Math.floor(Math.random() * 100000)}`;
  return (
    <>
      <FontAwesomeIcon
        id={id}
        icon={faQuestionCircle}
        className="text-primary"
      />
      <UncontrolledTooltip placement="auto" target={id} hideArrow={true}>
        {props.msg}
      </UncontrolledTooltip>
    </>
  );
};

export default HelpTooltip;
